import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Check, X } from "lucide-react";
import { toast } from "sonner";

export default function IscrizioniPage() {
  const [iscrizioni, setIscrizioni] = useState([]);
  const [corsi, setCorsi] = useState([]);
  const load = async () => {
    const [i, c] = await Promise.all([api.get("/iscrizioni"), api.get("/corsi-pubblici")]);
    setIscrizioni(i.data); setCorsi(c.data);
  };
  useEffect(() => { load(); }, []);
  const update = async (id, stato) => {
    await api.put(`/iscrizioni/${id}?stato=${stato}`);
    toast.success("Aggiornato"); load();
  };
  const statoBadge = { nuova:"bg-blue-50 text-blue-800", in_valutazione:"bg-amber-50 text-amber-900", confermata:"bg-emerald-50 text-emerald-800", rifiutata:"bg-red-50 text-red-800" };
  return (
    <div className="p-4 sm:p-8">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.2em] text-[#F7941E] mb-2">Portale Pubblico</div>
        <h1 className="text-3xl font-bold text-stone-900">Pre-iscrizioni Online</h1>
        <p className="text-stone-600 mt-1">Richieste dal form pubblico</p>
      </div>
      <Card className="p-4 bg-white border-[#E2E8F0]">
        <Table>
          <TableHeader><TableRow><TableHead>Data</TableHead><TableHead>Nome</TableHead><TableHead>Email</TableHead><TableHead>Corso richiesto</TableHead><TableHead>Stato</TableHead><TableHead className="text-right">Azioni</TableHead></TableRow></TableHeader>
          <TableBody>
            {iscrizioni.map(i => {
              const c = corsi.find(x=>x.id===i.corso_id);
              return (
                <TableRow key={i.id} data-testid={`iscrizione-${i.id}`}>
                  <TableCell className="text-sm">{i.created_at?.slice(0,10)}</TableCell>
                  <TableCell className="font-medium">{i.nome} {i.cognome}</TableCell>
                  <TableCell className="text-sm">{i.email}</TableCell>
                  <TableCell className="text-sm">{c?.titolo || i.corso_id}</TableCell>
                  <TableCell><Badge className={statoBadge[i.stato]}>{i.stato.replace("_"," ")}</Badge></TableCell>
                  <TableCell className="text-right space-x-1">
                    {i.stato === "nuova" && <>
                      <Button size="sm" variant="outline" onClick={()=>update(i.id, "confermata")} className="border-emerald-300 text-emerald-700"><Check className="w-3 h-3"/></Button>
                      <Button size="sm" variant="outline" onClick={()=>update(i.id, "rifiutata")} className="border-red-300 text-red-600"><X className="w-3 h-3"/></Button>
                    </>}
                  </TableCell>
                </TableRow>
              );
            })}
            {iscrizioni.length===0 && <TableRow><TableCell colSpan={6} className="text-center text-stone-500">Nessuna richiesta.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
